import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

import { RemoveIcon } from '../RemoveIcon/RemoveIcon'

type Props = ComponentPropsWithoutRef<'button'>

/**
 * 削除などで利用するボタン
 */
export const RemoveIconButton: FC<Props> = ({
  className,
  disabled,
  ...props
}) => {
  return (
    <button
      type="button"
      {...props}
      disabled={disabled}
      className={clsx(['rounded-full outline-primary', className])}
    >
      <RemoveIcon
        className={clsx(['text-gray-1 ', !disabled && 'hover:text-gray-2'])}
      />
    </button>
  )
}
